import React from 'react';

import colors from '../theme/colors';

type SelectionActionBarProps = {
  count: number;
  label: string;
  children: React.ReactNode;
};

const SelectionActionBar: React.FC<SelectionActionBarProps> = ({
  count,
  label,
  children,
}) => (
  <div className="flex justify-center p-4">
    <div
      className="flex items-center gap-3 rounded-lg p-4"
      style={{ backgroundColor: colors.safeLifeDarker, color: colors.white }}>
      <div
        className="rounded px-2"
        style={{ backgroundColor: colors.white, color: colors.textDefault }}>
        {count}
      </div>
      {label}
      {children}
    </div>
  </div>
);

export default SelectionActionBar;
